var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-calendar"},[_c('ul',[_vm._l((_vm.dates),function(field,i){return _c('GridCalendarDate',{key:i,attrs:{"date":_vm._f("fieldValue")(_vm.object,field),"title":_vm._f("fieldLabel")(field)}})}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }